<template>
  <nut-infiniteloading
    @loadmore="loadMoreClick"
    :is-show-mod="isShowMod"
    :has-more="!isNoMore"
    :is-loading="isLoading"
    :unload-more-txt="noMoreText"
    :threshold="threshold"
  >
    <slot name="list"></slot>
    <no-data :data="data"/>
  </nut-infiniteloading>
</template>

<script>
/**
 * ListLoading 无限加载组件 <br>
 * 封装nut-infiniteloading ,no-data 等组件 <br>
 * 支持滚动加载 无数据优化显示<br>
 * 若要支持分页 须在 @loadlist 回调加载数据方法 然后在回调方法实现组件setRes(data)方法  传入请求服务器返回的data数据
 */
export default {
  name: 'ListLoading',
  props: {
    /**
     * 传入数据用于判断当前是否显示 判断依据<br>
     * 注: 必须添加.sync 修饰符 用于支持父组件数据更新
     * array 空数组<br>
     * object 空对象<br>
     * string 空字符串<br>
     * Number 0<br>
     * val null<br>
     */
    data: {
      type: Object | Array | String | Number,
      default: null
    },
    /**
     * 分页参数 数据起始页 <br>
     *  注: 必须添加.sync 修饰符 用于支持父组件数据更新
     */
    page: {
      type: Number,
      default: 1
    },
    /**
     * 分页参数 每页数据大小<br>
     * 注: 必须添加.sync 修饰符 用于支持父组件数据更新
     */
    limit: {
      type: Number,
      default: 20
    },
    /**
     * 没有更多了 文案*/
    noMoreText: {
      type: String,
      default: '哎呀，这里是底部了啦'
    },
    /**
     * 距离底部多远加载
     */
    threshold: {
      type: Number,
      default: 200
    },
    /**
     * 是否展示懒加载模块内容，一般适用于选项卡切换
     */
    isShowMod: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isLoading: false,
      isNoMore: false,
      totalCounts: 0
    }
  },
  methods: {
    /**
     * 设置data数据 <br>
     *  res 数据必须包含<br>
     *    <ul>
     *    <li>data 数据字段
     *    <li>count 数据总条数字段
     *    </ul>
     */
    setRes (res) {
      //停止加载
      this.isLoading = false
      let { data, count } = res
      //设置数据
      if (this.page > 1) {
        this.$emit('update:data', this.data.concat(data))
      } else {
        this.$emit('update:data', data)
      }
      //判断是否还有更多数据
      if (this.data.length < count) {
        this.isNoMore = false
      } else if (this.data.length != 0) {
        this.isNoMore = true
      }
      this.totalCounts = count
    },
    /**滚动加载更多回调*/
    loadMoreClick () {
      this.isLoading = true
      if (this.page * this.limit < this.totalCounts) {
        this.$emit('update:page', this.page + 1)
      }
      this.$emit('loadlist')
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/common/comp/ListLoading/ListLoading.vue